import AppConstants from "../../../../../config/app.constants";
import LocationDistanceBaseController from "../common/location_distance.base.controller";

class LocationDistanceAllController {
    /*@ngInject*/
    constructor(Auth, User, $state, $translate, $stateParams, $location, Modal, LocationDistanceService) {
        this.Auth = Auth;
        this.User = User;
        this.$state = $state;
        this.$translate = $translate;
        this.$stateParams = $stateParams;
        this.$location = $location;
        this.Modal = Modal;
        this.LocationDistanceService = LocationDistanceService;

        this.model = {
            locationDistanceObj: {
                totalRecords: 0,
                results: [],
                loading: false
            },
            pagination: {
                page: 1,
                total: 0,
                pageLimit: 10,
                maxPages: 10
            },
            errorMessage: '',
            branchId: User.getUser().branchId,
            searchText: ''
        }
    }

    $onInit() {
        this.loadData();
    }

    searchObj() {
        const obj = {
            queryJSON: {
                rules: [{
                    group: {
                        rules: [{
                            field: 'label',
                            condition: 'like',
                            data: '%' + this.model.searchText + '%'
                        }],
                        operator: 'OR'
                    }
                }],
                operator: 'AND'
            }
        }
        return obj.queryJSON.rules.length ? obj : null;
    }

    loadLocationDistance() {
        this.model.locationDistanceObj.loading = true;

        this.LocationDistanceService.all(this.searchObj(), (this.model.pagination.page - 1) * this.model.pagination.pageLimit, this.model.pagination.pageLimit)
            .then((data) => {
                this.model.locationDistanceObj.results = data.results;
                this.model.locationDistanceObj.totalRecords = data.total;
            })
            .catch((err) => {
                this.Modal.errorModal(err.data.message);
            })
            .finally(() => {
                this.model.locationDistanceObj.loading = false;
            })
    }

    pageChange() {
        let newUrl = (window.location.pathname).replace('/' + this.$stateParams.page, '/' + this.model.pagination.page)
        this.$stateParams.page = this.model.pagination.page;
        this.$location.path(newUrl);
        this.loadLocationDistance();
    }

    loadData() {
        this.model.pagination.page = 1;
        this.loadLocationDistance();
    }

    search() {
        this.pageChange();
    }

    edit(locationDistanceObj) {
        this.$state.go('location_distance.edit', ({
            id: locationDistanceObj.id
        }))
    }
}

export default LocationDistanceAllController;


// WEBPACK FOOTER //
// ./client/app/components/tnt_billing/components/location_distance/all/location_distance.all.controller.js